import types from '../type';
/**
 *  date formatting 
 * @param {string} fmt  format mode  ( See dateFormats object )
 * @param {Date} date  date object 
 * eg: 2020-07-24 18:37:10
 *  Year ：yyyy -> 2020,  yy ->  20 ( take the last two digits )
 *  moon ：MM ->  07, MMM -> Jul, MMMM -> July
 *  day ：dd ->  24
 *  Week ：ww ->  Fri
 *  hour : HH ->  18, hh -> 06(12 hour system )
 *  point : mm -> 37
 *  Second : ss -> 10
 *  millisecond ：sss
 * p： PM or AM
 */
export default function format(fmt = 'yyyy-MM-dd hh:mm:ss', date = new Date()) {
    if (typeof date === 'string' && date) {
        //  string-compatible  -  segmentation 
        date = date.replace(/-/g, '/');
    }
    date = new Date(date);

    var fmts = fmt.match(/(\w)\1*/g).sort();
    for (var i = fmts.length - 1; i >= 0; i--) {
        let fmtValue = dateFormats[fmts[i]] && dateFormats[fmts[i]].call(date);
        if (types.isNull(fmtValue)) {
            continue;
        }
        if (!isNaN(fmtValue) && fmtValue < 10) {
            fmtValue = '0' + fmtValue;
        }
        fmt = fmt.replace(fmts[i], fmtValue);
    }
    return fmt;
}

function getLanguageMonth(locale) {
    const formatter = new Intl.DateTimeFormat(locale, { month: 'long' });
    return Array.from({ length: 12 }, (_, mon) =>
        formatter.format(new Date(1970, mon, 1))
    );
}
function getLanguageSimpleMonth(locale) {
    const formatter = new Intl.DateTimeFormat(locale, { month: 'short' });
    return Array.from({ length: 12 }, (_, mon) =>
        formatter.format(new Date(1970, mon, 1))
    );
}
function getLanguageWeek(locale) {
    const base = new Date(1970, 0, 1).getTime();
    const formatter = new Intl.DateTimeFormat(locale, { weekday: 'short' });
    return Array.from(
        { length: 7 },
        (_, day) => formatter.format(new Date(base + 3600000 * 24 * (-4 + day))) // 1970.1.1  it's thursday 
    );
}
export function getLngTime(locale = 'en') {
    TIME_NAMES.WEEK_NAMES = getLanguageWeek(locale);
    TIME_NAMES.MONTH_SIMPLE_NAMES = getLanguageSimpleMonth(locale);
    TIME_NAMES.MONTH_NAMES = getLanguageMonth(locale);
}

export const TIME_NAMES = {
    WEEK_NAMES: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    MONTH_SIMPLE_NAMES: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    MONTH_NAMES: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};

const dateFormats = {
    yyyy: function () {
        return this.getFullYear();
    },
    yy: function () {
        return this.getFullYear() % 100;
    },
    MM: function () {
        return this.getMonth() + 1;
    },
    MMM: function () {
        return TIME_NAMES.MONTH_SIMPLE_NAMES[this.getMonth()];
    },
    MMMM: function () {
        return TIME_NAMES.MONTH_NAMES[this.getMonth()];
    },
    dd: function () {
        return this.getDate();
    },
    ww: function () {
        return TIME_NAMES.WEEK_NAMES[this.getDay()];
    },
    HH: function () {
        return this.getHours();
    },
    hh: function () {
        var hour = this.getHours();
        return hour <= 12 ? (hour === 0 ? 12 : hour) : hour - 12;
    },
    mm: function () {
        return this.getMinutes();
    },
    ss: function () {
        return this.getSeconds();
    },
    sss: function () {
        return this.getMilliseconds();
    },
    p: function () {
        return this.getHours() >= 12 ? 'PM' : 'AM';
    }
};
